// src/components/Room/DeleteAllDevicesInRoomButton.tsx
import React from "react";
import { ActionIcon, Tooltip, Text } from "@mantine/core";
import { FaTrash } from "react-icons/fa6";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectProjectNo } from "../../sharedSelectors";
import { modals } from "@mantine/modals";
import { usePostMultiplacerDeviceDeleteInRoomsMutation } from "../../../openapi";
import { selectHttpSingleRoomFull } from "../../Room/httpRoomSelectors";

export const DeleteAllDevicesInRoomButton: React.FC = () => {
  const dispatch = useAppDispatch();
  const projectNo = useAppSelector(selectProjectNo);
  const selectedSpaceNumber = useAppSelector((state) => state.design.selectedSpaceNumber) as
    | string
    | null;

  const singleRoom = useAppSelector(selectHttpSingleRoomFull);
  const isLocked = singleRoom?.multiplacerCeilingDevicesLocked?.bool === true;

  const [deleteInRooms, { isLoading }] = usePostMultiplacerDeviceDeleteInRoomsMutation();

  const handleConfirmDelete = async () => {
    if (!selectedSpaceNumber) {
      console.warn("Ingen valgt rom – kan ikke slette komponenter.");
      return;
    }

    try {
      await deleteInRooms({
        body: {
          projectNo,
          roomNumbers: [selectedSpaceNumber], // ett rom i arrayen
        },
      }).unwrap();

      // TODO: evt. trigge refetch / lokalt state-reset om det trengs
      // f.eks: dispatch(refetchDevicesInCurrentRoomThunk());
    } catch (error) {
      console.error("Feil ved sletting av komponenter i rom", error);
    }
  };

  const handleClick = () => {
    modals.openConfirmModal({
      title: "Fjern alle komponenter?",
      children: (
        <Text size="sm">
          Er du sikker på at du vil fjerne alle komponenter i dette rommet? Dette kan ikke angres.
        </Text>
      ),
      labels: { confirm: "Ja, fjern alle", cancel: "Avbryt" },
      cancelProps: { variant: "neutral" },
      confirmProps: { color: "red" },
      onConfirm: handleConfirmDelete,
    });
  };

  const effectiveDisabled = isLoading || isLocked;

  return (
    <Tooltip label="Fjern alle komponenter i dette rommet">
      <ActionIcon
        h={30}
        w={30}
        variant="subtle"
        color="red"
        radius="md"
        disabled={effectiveDisabled}
        onClick={handleClick}
      >
        <FaTrash size={14} />
      </ActionIcon>
    </Tooltip>
  );
};
